const CANAL_SANKHYA = 'SANKHYA'
const MARCA_SANKHYA = 'Sankhya RH'
const TEMA_PONTOTEL = 'pontotel'
const TEMA_SANKHYA = 'sankhya'
const PADRAO_MARCA_OU_REFERENCIA_TECNICA = new RegExp([
  '(?:https?:\\/\\/|www\\.)[^\\s<>"\']+',
  '[^\\s<>"\']+@[^\\s<>"\']+',
  '@[a-z0-9_.-]+(?:\\/[a-z0-9_.-]+)?',
  '[a-z][a-z0-9+.-]*:[^\\s<>"\']+',
  '[?#][^\\s<>"\']+',
  '\\/[^\\s<>"\']+',
  '(?:[a-z0-9-]+\\.)+pontotel(?:\\.[a-z0-9-]+)*',
  'pontotel(?:\\.[a-z0-9-]+)+',
  '[a-z0-9_-]*pontotel[a-z0-9_-]+',
  '[a-z0-9_-]+pontotel[a-z0-9_-]*',
  'pontotel'
].join('|'), 'gi')

export interface EstadoAplicacao {
  userInfo?: {
    compMan?: {
      canalWhitelabel?: string;
      id?: string;
      isSankhya?: boolean;
    };
  } | null;
}

const obterJanelaAtual = (): Window | null => {
  return typeof window === 'undefined' ? null : window
}

export const aplicacaoEstaEmIframe = (janela: Window | null = obterJanelaAtual()): boolean => {
  if (!janela) return false

  try {
    return janela.self !== janela.top
  } catch {
    return true
  }
}

export const contextoUsaMarcaSankhya = (
  estado: EstadoAplicacao = {},
  janela: Window | null = obterJanelaAtual()
): boolean => {
  const canalEhSankhya = estado.userInfo?.compMan?.canalWhitelabel === CANAL_SANKHYA

  return canalEhSankhya || aplicacaoEstaEmIframe(janela)
}

export const obterTemaWhitelabel = (
  estado: EstadoAplicacao = {},
  empresasComWhiteLabel: readonly string[] = [],
  janela: Window | null = obterJanelaAtual()
): string => {
  const compMan = estado.userInfo?.compMan

  if (contextoUsaMarcaSankhya(estado, janela) || compMan?.isSankhya) {
    return TEMA_SANKHYA
  }

  if (compMan?.id && empresasComWhiteLabel.includes(compMan.id)) {
    return compMan.id
  }

  return TEMA_PONTOTEL
}

export const aplicarMarcaWhitelabel = (
  texto: string,
  estado: EstadoAplicacao = {},
  janela: Window | null = obterJanelaAtual()
): string => {
  if (!contextoUsaMarcaSankhya(estado, janela)) return texto

  return texto.replace(PADRAO_MARCA_OU_REFERENCIA_TECNICA, ocorrencia => {
    return ocorrencia.toLowerCase() === 'pontotel' ? MARCA_SANKHYA : ocorrencia
  })
}
